/**
 * Dry-discounted JS for proper add-to-cart
 *
 * https://www.wrike.com/open.htm?id=901483591
 */
( $ => {
	/* global _dry_food_discount */
	
	/**
	 * Perform cart update action on campaign page
	 *
	 * @param e
	 * @param act
	 * @param data
	 * @returns {boolean}
	 * @private
	 */
	const __cart_action = ( e, act, data ) => {
		let _el = $( e.target );
		_el.prop( 'disabled', true ).addClass( 'disabled' );
		$.post(
			_dry_food_discount.ajax_url + '?nocache=' + Date.now(),
			{
				action: _dry_food_discount.action,
				perform: act,
				data: data || _el.data(),
			},
			__success_handler,
		).then( () => {
			_el.prop( 'disabled', false ).removeClass( 'disabled' );
			$( '.close-details' ).trigger( 'click' );
		} );
		e.preventDefault();
		e.stopPropagation();
		return false;
	};
	
	/**
	 * Add discounted product to cart
	 *
	 * @param e
	 * @returns {boolean}
	 * @private
	 */
	const __add_discounted_product_to_cart = e => {
		return __cart_action( e, 'add' );
	};
	
	/**
	 * Add discounted product to cart
	 *
	 * @param e
	 * @returns {boolean}
	 * @private
	 */
	const __remove_discounted_product = e => {
		return __cart_action( e, 'remove' );
	};
	
	/**
	 * Remove discounted product from cart
	 *
	 * @param e
	 * @returns {boolean}
	 * @private
	 */
	const __update_discounted_product = e => {
		let _dat = {};
		_dat[ e.target.name ] = $( e.target ).val();
		return __cart_action( e, 'update', _dat );
	};


	/**
	 * Show additional product info
	 *
	 * @param e
	 * @returns {boolean}
	 * @private
	 */
	const __show_info = e => {
		$( 'html, body' ).addClass( 'no-scroll' );

		const id = $( e.currentTarget ).parents( '.product-card' ).data( 'id' );
		$( '#product-details-' + id ).removeClass( 'hidden' );

		e.preventDefault();
		e.stopPropagation();
		return false;
	};


	/**
	 * Update page elements once ajax response has been received
	 *
	 * @param response
	 * @private
	 */
	const __success_handler = response => {
		if ( response.error )
			return console.log( response );
		$( '#site-header-cart .cart-contents__count' ).html( response.count );
		$( '#site-header-cart .wtc-mini-cart' ).replaceWith( response.mini_cart );
		$( '.buddy-cart-refreshable' ).replaceWith( response.cart );
		$( '#page' ).trigger( 'dry_food_discount_cart_updated' );
		$( document.body ).trigger( 'mini_cart_updated' );

		__scroll_to_cart();
	};
	
	/**
	 * Scroll to cart section
	 *
	 * @param e
	 * @returns {boolean}
	 * @private
	 */
	const __scroll_to_cart = function( e ){
		const elem = $( '.dry-food-discounted-products' );
		$( 'html, body' ).stop().animate( { scrollTop: elem.offset().top + elem.height() - 100 }, 1000 );
		if( e ){
			e.preventDefault();
			e.stopPropagation();
		}
		return false;
	}


	/**
	 * Assign event listeners
	 *
	 * @private
	 */
	const __assign = function() {
		$( document.body ).on( 'click', '.discounted-add-to-cart .button--add-to-cart', __add_discounted_product_to_cart );
		$( document.body ).on( 'change', '.update-original', __update_discounted_product );
		$( document.body ).on( 'click', '.buddy-cart-dry-food-discount a.remove', __remove_discounted_product );
		$( document.body ).on( 'click', '.open-product-details', __show_info );
		$( document.body ).on( 'click', '.site-header-cart', __scroll_to_cart );
		console.log( '[theme] Dry-discounted JS initiated!' );
	};


	/**
	 * Initialize
	 *
	 * @private
	 */
	const __init = () => {
		setTimeout( __assign, 900 );
	};

	return {
		init: function() {
			if ( !$( '.dry-food-discounted-products' ).length ) return;

			if ( document.readyState === 'complete' ) {
				__init();
			} else {
				window.addEventListener( 'load', function() {
					__init();
				} );
			}
		},
	};

} )( jQuery.noConflict() ).init();
